
module.exports = function (request, currentRoute, data= {}) {
  return {status: currentRoute};
};
